import {inject, Injectable} from '@angular/core';
import {environment} from "@environment/environment";
import {Observable} from "rxjs";
import { HttpClient } from "@angular/common/http";
import {Group, GroupUser} from "./store/groups.state";

@Injectable()
export class GroupsService {
  private url: string = environment.backendBaseUrl
  private readonly httpClient: HttpClient = inject(HttpClient);

  getGroupsWhereUserIsAdmin(): Observable<Group[]> {
    return this.httpClient.get<Group[]>(`${this.url}/admin-groups`)
  }

  getGroupById(id: string): Observable<Group> {
    return this.httpClient.get<Group>(`${this.url}/group/${id}`)
  }

  registerUserToGroup(id: string, user: GroupUser): Observable<void> {
    return this.httpClient.post<void>(`${this.url}/group/${id}/member`, user)
  }

  removeUserFromGroup(groupId: string, email: string): Observable<void> {
    return this.httpClient.delete<void>(`${this.url}/group/${groupId}/member/${email}`)
  }

  addManyToGroup(id: string, file: File): Observable<void> {
    const formData = new FormData()
    formData.append('file', new Blob([file], {type: 'text/csv'}), file.name)
    return this.httpClient.post<void>(`${this.url}/group/${id}/add-many`, formData)
  }
}
